import { ProductInstruction } from './ProductInstruction'

export const isWbRandomOrder = (orders, type) => type === 'random' && /^WB-\d+$/.test(String(orders?.orderNumber || ''))

export function WbRandomInstruction() {
  return <ProductInstruction title='Как получить и активировать игру' hint='Россия и страны СНГ · покупка на Wildberries'>
    <ol>
      <li>Нажмите «Получить игру» и дождитесь выбранной игры. Проверьте её название, язык и системные требования по ссылке на SteamDB.</li>
      <li>Если игра подходит, нажмите «Получить», чтобы увидеть ключ. До выдачи ключа доступна одна «Замена»: новая игра и её ключ выдаются сразу.</li>
      <li>Войдите в свой аккаунт Steam региона Россия или одной из стран СНГ. В приложении откройте «Игры» → «Активировать в Steam» и введите ключ.</li>
    </ol>
    <p>Одна покупка — одна случайная игра выбранного уровня. После выдачи ключа замена недоступна. Сохраните эту ссылку: повторное открытие показывает тот же результат.</p>
    <p>По вопросам покупки напишите продавцу в чате своего заказа на Wildberries и укажите номер заказа, показанный выше.</p>
  </ProductInstruction>
}
